export const  TiposAlmacenEnum  = Object.freeze({
  CENTRO_TRABAJO: 1,
  BODEGA: 2,
  PLANTA: 3,
  ALMACEN: 4
})
export const  AreaAlmacenEnum  = Object.freeze({
  PRODUCCION: 1,
  LOGISTICA: 2,
  CALIDAD: 3,
  CUARENTENA: 4,
  EXTERNO: 5,
  SCRAP: 6,
})

export const AreaAlmacenArray = [
  {
    id: 1,
    name: "Producción",
  },
  {
    id: 2,
    name: "Logística",
  },
  {
    id: 3,
    name: "Calidad",
  },
  {
    id: 4,
    name: "Cuarentena",
  },
  {
    id: 5,
    name: "Externo",
  },
  {
    id: 6,
    name: "SCRAP",
  }
]